// Status calculation method enum
export const statusCalculationMethodData360LiveEnum = {
  Instantaneous: "Instantaneous",
  AvgByPass: "AvgByPass", 
  AvgByZone: "AvgByZone",
  AvgByTilt: "AvgByTilt",
};


// Get status value for Pass View table (your specific logic)
export const getPassStatus = (statusCalculationMethod: string, record: any) => {
  
  let result;
  switch (statusCalculationMethod) {
    case statusCalculationMethodData360LiveEnum.Instantaneous:
      result = record.pass_status_by_instantaneous || record.statusByInstantaneous;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByPass:
      result = record.pass_avg_status || record.statusByAvgPass;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByZone:
    case statusCalculationMethodData360LiveEnum.AvgByTilt:
      result = record.pass_staus_by_zone;
      break;
    default:
      result = record.pass_status_by_instantaneous || record.statusByInstantaneous;
  }
  
  return result;
};

// Get status value for Weld Status main table (correct logic)
export const getWeldStatusCalculationMethod = (statusCalculationMethod: string, record: any) => {
  let result;
  switch (statusCalculationMethod) {
    case statusCalculationMethodData360LiveEnum.Instantaneous:
      result = record.pass_status_by_instantaneous || record.statusByInstantaneous;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByPass:
      result = record.pass_avg_status || record.statusByAvgPass;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByZone:
      result = record.pass_staus_by_zone || record.statusByAvgZone;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByTilt:
      result = record.statusByAvgTilt;
      break;
    default:
      result = record.pass_status_by_instantaneous || record.statusByInstantaneous;
  }

  return result;
};

// Get status value for Zone level
export const getZoneStatus = (statusCalculationMethod: string, record: any) => {
  
  let result;
  switch (statusCalculationMethod) {
    case statusCalculationMethodData360LiveEnum.Instantaneous:
      result = record.zone_status_by_instantaneuous;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByPass:
    case statusCalculationMethodData360LiveEnum.AvgByZone:
    case statusCalculationMethodData360LiveEnum.AvgByTilt:
      result = record.avg_zone_status;
      break;
    default:
      result = record.zone_status_by_instantaneuous;
  }
  
  return result;
};

// Get status value for Tilt level
export const getTiltStatus = (statusCalculationMethod: string, record: any) => {
  
  let result;
  switch (statusCalculationMethod) {
    case statusCalculationMethodData360LiveEnum.Instantaneous:
      result = record.avg_staus_by_instantaneous;
      break;
    case statusCalculationMethodData360LiveEnum.AvgByPass:
    case statusCalculationMethodData360LiveEnum.AvgByZone:
    case statusCalculationMethodData360LiveEnum.AvgByTilt:
      result = record.avg_tilt_status;
      break;
    default:
      result = record.avg_staus_by_instantaneous;
  }
  
  return result;
};

// Get status value for individual row data
export const getRowStatus = (statusCalculationMethod: string, record: any, level: 'pass' | 'zone' | 'tilt') => {
  switch (level) {
    case 'pass':
      return getPassStatus(statusCalculationMethod, record);
    case 'zone':
      return getZoneStatus(statusCalculationMethod, record);
    case 'tilt':
      return getTiltStatus(statusCalculationMethod, record);
    default:
      return record.pass_status_by_instantaneous;
  }
};

// Get status color class based on status value
export const getStatusColorClass = (status: any) => {
  if (status === null || status === undefined) return 'text-gray-400';
  
  const statusStr = String(status).toLowerCase();
  
  if (statusStr.includes('pass') || statusStr === 'true' || statusStr === '1') {
    return 'text-green-600';
  } else if (statusStr.includes('fail') || statusStr === 'false' || statusStr === '0') {
    return 'text-red-600';
  } else if (statusStr.includes('warning') || statusStr.includes('caution')) {
    return 'text-yellow-600';
  } else {
    return 'text-gray-600';
  }
};

// Get status badge class based on status value
export const getStatusBadgeClass = (status: any) => {
  if (status === null || status === undefined) return 'bg-gray-100 text-gray-600';
  
  const statusStr = String(status).toLowerCase();
  
  if (statusStr.includes('pass') || statusStr === 'true' || statusStr === '1') {
    return 'text-galvanizing-green bg-[rgba(31,154,58,0.08)]';
  } else if (statusStr.includes('fail') || statusStr === 'false' || statusStr === '0') {
    return 'text-readable-red bg-[rgba(196,0,31,0.06)]';
  } else if (statusStr.includes('warning') || statusStr.includes('caution')) {
    return 'text-[#B38600] bg-[rgba(230,161,0,0.08)]';
  } else {
    return 'bg-gray-100 text-gray-600';
  }
};
